module.exports = __webpack_public_path__ + "static/media/space-1.d63f1d7b.png";